<template lang="pug">
#news-view
  second-menu(:selectorid="'tab-selector-base'", :tabs="tabs", :synctab.sync="selectedTab", ':is-sticky'='true')
  .banner.bg-cover.hidden-xs(:class="{'banner-circular':selectedTab=='circular', 'banner-announcement':selectedTab=='announcement', 'banner-financial':selectedTab=='financial', 'banner-media':selectedTab=='media'}")
  #news-view-content
    router-view
</template>

<script>
import  router from './../../router'
import Uri from 'urijs'
import SecondMenu from '../second-menu.vue'

let tabs = [
  {
    title: window.wordDict.NEWS_MEDIA,
    id: 'media',
  },
  // {
  //   title: window.wordDict.NEWS_FR,
  //   id: 'financial',
  // },
  {
    title: window.wordDict.NEWS_AN,
    id: 'announcement',
  },
  // {
  //   title: window.wordDict.NEWS_CIRCULARS,
  //   id: 'circular',
  // }
]


export default {
  data () {
    return {
      selectedTab: Uri().segment(1),
      tabs,
    }
  },
  computed: {},
  ready () {
    console.log(this.$route);
    if (!this.selectedTab) {
      this.selectedTab = 'media';
    }
  },
  watch: {
    selectedTab(val) { router.go(`/news/${val}`) },
  },
  methods: {},
  components: {
    SecondMenu
  }
}
</script>

<style lang="scss" scoped>
@import "global";
.banner {
  padding-bottom: 40%;
  margin-bottom: 40px;
  margin-top: 0;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  &.banner-media {
    background-image: url('../../images/news/2-3_3_News_Media.jpg');
  }
  &.banner-circular {
    background-image: url('../../images/news/2-3_3_News_circulars.jpg');
  }
  &.banner-announcement {
    background-image: url('../../images/news/2-3_3_News_Announcement.jpg');
  }
  &.banner-financial {
    background-image: url('../../images/news/2-3_3_News_Fin_report.jpg');
  }
}
@media (max-width:$grid-float-breakpoint-max) {
  .banner {
    height: 0;
    padding-bottom: 52%;
  }
  #news-view-content {
    margin-top: $responsive-mdl-selector-height + 1px;
  }
}
</style>

<style lang="scss">
@import "global";
#news-view {
  @media (max-width:$grid-float-breakpoint-max) {
    #year-selector-dropdown {
      display: none;
    }
    #tab-selector-year {
      left: 70%;
      width: 30%;
      display: inherit;
    }
    #tab-selector-base {
      width: 70%;
      .mdl-tabs__tab {
        border-right: $responsive-mdl-selector-border;
      }
    }
    .tab-select-icon {
      right: 12px;
    }
    section {
      padding: 16px;
      &:not(:first-child) {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 16px;
      }
    }
    .container {
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// news-page.vue?68b9f75e